import { render, staticRenderFns } from "./LocalMaterial.vue?vue&type=template&id=cb17b25e&scoped=true"
import script from "./LocalMaterial.vue?vue&type=script&lang=js"
export * from "./LocalMaterial.vue?vue&type=script&lang=js"
import style0 from "./LocalMaterial.vue?vue&type=style&index=0&id=cb17b25e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb17b25e",
  null
  
)

export default component.exports